import service from "@/utils/request"

export function totalDataApi(params) {
    return service({
        url: "/dataCenter/company/businessAnalysis/companyTotalData",
        method: "get",
        params
    })
}

// 查询总销售额
export function getTotalSalesRevenueApi(params) {
    return service({
        url: '/dataCenter/company/businessAnalysis/getCompanyTotalSalesRevenue',
        method: 'get',
        params
    })
}

// 查询订单笔数
export function getCompanyTotalOrderCountApi(params) {
    return service({
        url: '/dataCenter/company/businessAnalysis/getCompanyTotalOrderCount',
        method: 'get',
        params
    })
}

// 查询30日销售额
export function getThirtyDaySalesRevenueApi(params) {
    return service({
        url: '/dataCenter/company/businessAnalysis/getCompanyThirtyDaySalesRevenue',
        method: 'get',
        params
    })
}

// 获取查询30日订单笔数
export function getMonthOrderCountApi(params) {
    return service({
        url: '/dataCenter/company/businessAnalysis/getCompanyMonthOrderCount',
        method: 'get',
        params
    })
}

// 获取查询店铺销量排行榜
export function getStoreSalesPriceRevenue(params) {
    return service({
        url: '/dataCenter/businessAnalysis/getStoreSalesPriceRevenue',
        method: 'get',
        params
    })
}

